// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IBookInviteRecipientEligibilityItem,
}                               from '../interfaces';

const getBookInviteRecipientEligibility = async ({
    test,
    emails,
}: {
    test: boolean,
    emails: string[],
}): Promise<IBookInviteRecipientEligibilityItem[]> => {
    const functions = getFunctions();
    const handleGetBookInviteRecipientEligibility = httpsCallable<
        Record<
            string,
            boolean | string[]
        >,
        IBookInviteRecipientEligibilityItem[]
    >(
        functions,
        'getBookInviteRecipientEligibility',
    );
    return handleGetBookInviteRecipientEligibility({
        test,
        emails: [...emails],
    }).then((result) => {
        const eligibilityItems = result.data as IBookInviteRecipientEligibilityItem[];
        return eligibilityItems;
    }).catch((err) => {
        throw err;
    });
};

export default getBookInviteRecipientEligibility;
